module.exports = __webpack_public_path__ + "img/sawicki.e6d22e69.jpg";